export default __webpack_public_path__ + "static/media/Time.f1c0cbbe.svg";